import React from 'react';
import { Cross2Icon } from '@radix-ui/react-icons';

import {
  FilterTrigger,
  FilterTitle,
  LowContrastText,
} from '../../tasks/components/styled-tasks-components';

type CrewFilterChipProps = {
  /** 'Department' or 'Team'. */
  title: string;
  /** The selected values for this category. Always non-empty — the caller only renders a chip
      for an active category. */
  values: string[];
  onClear: () => void;
};

// Mirrors `ProjectFilterChip` (apps/webapp/src/features/tasks/components/project-tasks-filters):
// category name, then the single value or a count when several are selected, then a clear icon.
// Reuses the same styled primitives rather than restyling.
export const CrewFilterChip: React.FC<CrewFilterChipProps> = ({ title, values, onClear }) => {
  return (
    <FilterTrigger>
      <FilterTitle>
        {title}
        <LowContrastText>&nbsp;is&nbsp;</LowContrastText>
        {values.length > 1 ? `${values.length} selected` : values[0]}
      </FilterTitle>

      <Cross2Icon
        onPointerDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={onClear}
      />
    </FilterTrigger>
  );
};
